import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function Bonuses() {
  return <section className="bg-sand py-14 sm:py-20" data-id="element-104" data-mp="1cl643e2o3sj6">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-105" data-mp="1clz9obpw4bzq">
        <div className="text-center" data-id="element-106" data-mp="18jun1wxv0fml">
          <span className="inline-flex items-center gap-2 rounded-full bg-navy-900 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-sky-400 sm:text-xs" data-id="element-107" data-mp="18kvvrurekq15">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="20aikaxwex0uz" />
            5 exclusive bonuses — free
          </span>
          <h2 className="mt-5 font-display text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-109" data-mp="1w7ub2p3sdrxh">
            Today you also receive 5 professional bonuses at no additional cost
          </h2>
          <p className="mt-4 text-[15.5px] font-bold text-navy-900 sm:text-lg" data-id="element-110" data-mp="kursjoi4msao">
            Total bonus value: <span className="text-sky-600" data-id="element-111" data-mp="fu467g4uezms">$197</span> — included free with your purchase.
          </p>
        </div>

        <div className="mt-9 space-y-5" data-id="element-112" data-mp="1eug90jmu8qss">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/10" data-id="element-113" data-mp="1jrgi73ezi9o4">
              <img src={bonus.image} alt={`${bonus.title} bonus materials`} className="block w-full bg-white" width={1272} height={1272} loading="lazy" data-id="element-114" data-mp="15sgvi1b184ul" />
              <div className="p-5 sm:p-7" data-id="element-115" data-mp="10u5glc5vr45i">
                <div className="flex flex-wrap items-center gap-2" data-id="element-116" data-mp="10v6xhx9kukv5">
                  <span className="rounded-md bg-navy-900 px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-sky-400" data-id="element-117" data-mp="n3imjxb2e2fr">
                    {bonus.label}
                  </span>
                  <span className="rounded-md bg-gogreen-500/10 px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.1em] text-gogreen-700" data-id="element-118" data-mp="d5m9gzykgxf0">
                    Value: {bonus.value}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-[21px] font-bold leading-tight text-navy-900 sm:text-2xl" data-id="element-119" data-mp="2jueio24nbjp4">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-navy-800/80" data-id="element-120" data-mp="2b11iqg85zhtj">{bonus.intro}</p>

                {bonus.bullets ? <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-121" data-mp="25zc5qv1dsu2t">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2" data-id="element-122" data-mp="2yq3yfij8n0le">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-600" aria-hidden="true" data-id="element-123" data-mp="2ynzwh64wgbnr" />
                        <span className="text-[14.5px] leading-snug text-navy-800/85" data-id="element-124" data-mp="2orn2s89ctxt0">{bullet}</span>
                      </li>)}
                  </ul> : null}

                {bonus.closing ? <p className="mt-4 text-[15px] leading-relaxed text-navy-800/80" data-id="element-125" data-mp="1dc85f3d8h3xd">{bonus.closing}</p> : null}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-126" data-mp="1874ed0a6r3ys">
          <CTAButton label="Yes — I want the bonuses included" data-id="element-127" data-mp="187xbran98h49" />
        </div>
      </div>
    </section>;
}